// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBD7fqGVD4nGsSTSjBYCHKZIU-Wlg71tks",
  authDomain: "ivmedicaldynamics.firebaseapp.com",
  projectId: "ivmedicaldynamics",
  storageBucket: "ivmedicaldynamics.appspot.com",
  messagingSenderId: "728054409514",
  appId: "1:728054409514:web:0e0de8087dee1b678b9653",
  measurementId: "G-Q8C7CMJ190"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);